export const flatProducts = (categories, id, total) => {
  const products = categories.map(c => c.node.productsCategorie);
  // flat array
  const flat = [].concat.apply([], products);
  const uniqProduct = multiple(flat, total * 2);
  // remove duplicate
  return uniqProduct.reduce((acc, current) => {
    const x = acc.find(item => {
      return (
        item.frontmatter.id === current.frontmatter.id ||
        current.frontmatter.id === id
      );
    });
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);
};

export const uniq = array => {
  if (!Array.isArray(array)) {
    throw new TypeError('Expected an array');
  }
  return array[Math.floor(Math.random() * array.length)];
};

export const multiple = (array, count) => {
  if (!Number.isInteger(count) && count >= 0) {
    throw new TypeError('Expected a non-negative integer');
  }
  // const _count = count >= array.length ? array.length - 1 : count;
  return [...new Array(count)].map(() => uniq(array));
};
